// components/global/FixedRange.jsx
import React from 'react';
import { Range as OriginalRange } from 'react-range';

const FixedRange = (props) => {
  // Sobrescribir las funciones render para manejar la key correctamente
  const renderTrack = ({ props: trackProps, children, isDragged }) => {
    const { key, ...restTrackProps } = trackProps;
    return (
      <div key={key} {...restTrackProps}>
        {children}
      </div>
    );
  };

  const renderThumb = ({ props: thumbProps, index, isDragged }) => {
    const { key, ...restThumbProps } = thumbProps;
    return (
      <div key={key} {...restThumbProps} />
    );
  };

  return (
    <OriginalRange
      {...props}
      renderTrack={props.renderTrack || renderTrack}
      renderThumb={props.renderThumb || renderThumb}
    />
  );
};

export default FixedRange;